import * as React from "react"
import Svg, { Path } from "react-native-svg"

const DropdownIcon = (props) => (
    <Svg
        width="14"
        height="8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M7.384 7.831 13.842.98a.598.598 0 0 0-.001-.812.522.522 0 0 0-.768.001L7 6.613.927.169A.522.522 0 0 0 .16.168.59.59 0 0 0 0 .574.59.59 0 0 0 .158.98L6.616 7.83C6.717 7.94 6.856 8 7 8c.144 0 .282-.06.384-.169Z"
            fill="#242424"
        />
    </Svg>
)

export default DropdownIcon
